import { useState, useEffect } from 'react'
import noteService from '../../services/notes'
import NoteForm from './NoteForm'
import Note from './Note'
import styles from './Notes.module.css'
import Card from '../Card'

const Notes = ({ user, setNotification }) => {
  const [notes, setNotes] = useState(null)
  const [showAll, setShowAll] = useState(true)

  useEffect(() => {
    noteService.getAll().then(data => setNotes(data))
  }, [])

  const notesToShow = showAll
    ? notes
    : notes.filter(note => note.important)

  // Event Handlers

  const handleRemove = (e, id) => {
    e.preventDefault()
    if (
      window.confirm(
        'Are you sure you want to delete this note?'
      )
    ) {
      removeNote(id)
    }
  }

  const handleImportanceButton = id => {
    toggleImportanceOfNote(id)
  }

  // Service Calls

  const addNote = noteObject => {
    noteService
      .create(noteObject)
      .then(data => {
        setNotes(notes.concat(data))
        setNotification({
          message: 'Your new note was successfully added!',
          type: 'success',
        })
      })
      .catch(error => {
        setNotification({
          message: error.response.data.error,
          type: 'error',
        })
      })
  }

  const removeNote = id => {
    // service call that removes a note

    const newNotes = notes.filter(note => note.id !== id)

    noteService
      .remove(id)
      .then(() => {
        setNotification({
          message:
            'Success: Note was successfully deleted!',
          type: 'success',
        })
        setNotes(newNotes)
      })
      .catch(error => {
        setNotification({
          message: error.response.data.error,
          type: 'error',
        })
        setNotes(newNotes)
      })
  }

  const toggleImportanceOfNote = id => {
    const note = notes.find(n => n.id === id)
    const changedNote = {
      ...note,
      important: !note.important,
    }

    noteService
      .update(id, changedNote)
      .then(data => {
        setNotes(
          notes.map(note => (note.id !== id ? note : data))
        ) //TODO: Fails when updating unexisting note
        setNotification({
          message:
            'Success: The importance of your note was successfully updated!',
          type: 'success',
        })
      })
      .catch(() => {
        setNotification({
          message:
            'Error: this note was already removed from server!',
          type: 'error',
        })

        setNotes(notes.filter(note => note.id !== id))
      })
  }

  //Utility Functions

  if (!notes) {
    return null
  }
  return (
    <>
      <div style={{ margin: '2rem 1rem' }}>
        <button
          className="btn-accent-dark"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? '⭐  show important' : 'show all'}
        </button>
      </div>

      <div className={[styles['notes-layout']].join(' ')}>
        {user ? (
          <Card variant="empty">
            <NoteForm addNote={addNote} />
          </Card>
        ) : null}

        {notesToShow.map(note => (
          <Card key={note.id}>
            <Note
              note={note}
              toggleImportance={() =>
                handleImportanceButton(note.id)
              }
              handleRemove={e => handleRemove(e, note.id)}
              user={user}
            />
          </Card>
        ))}
      </div>
    </>
  )
}
export default Notes
